import React, { ElementType, FC } from "react";

import { Typography, TypographyProps, useTheme } from "@mui/material";

import { IgCustomTheme } from "./theme";

export type IgTypographyStyle = "semibold" | "link" | "linkNoBold";

export interface IgTypographyProps extends TypographyProps {
  component?: ElementType<any> | undefined;
  igStyle?: IgTypographyStyle;
}

/**
 * @see Typography
 */
export const IgTypography: FC<IgTypographyProps> = (props) => {
  const { children, igStyle, sx, ...rest } = props;
  const theme = useTheme();
  if (igStyle === "semibold") {
    return (
      <Typography
        component={"span"}
        variant={rest.variant || "body1"}
        {...rest}
        sx={{ fontWeight: 600, ...sx }}
      >
        {children}
      </Typography>
    );
  }
  if (igStyle === "link") {
    return (
      <Typography
        component={"span"}
        variant={rest.variant || "body1"}
        {...rest}
        sx={{
          color: `${(theme as IgCustomTheme).palette.text.accent} !important`,
          fontWeight: 600,
          "&:hover": { cursor: "pointer" },
          ...sx,
        }}
      >
        {children}
      </Typography>
    );
  }

  if (igStyle === "linkNoBold") {
    return (
      <Typography
        variant={rest.variant || "body1"}
        component={"span"}
        {...rest}
        sx={{
          color: `${(theme as IgCustomTheme).palette.text.accent} !important`,
          "&:hover": { cursor: "pointer" },
          ...sx,
        }}
      >
        {children}
      </Typography>
    );
  }

  return (
    <Typography
      {...rest}
      component={"span"}
      variant={rest.variant || "body1"}
      sx={{ ...sx }}
    >
      {children}
    </Typography>
  );
};
